import React from 'react';
import Button from '@/components/Button';

interface MoreButtonProps {
  setSize: () => void;
}

const MoreButton: React.FC<MoreButtonProps> = ({ setSize }) => (
  <div className="flex w-full justify-end">
    <Button className="mt-sh-15" theme="outline" onClick={setSize}>
      MORE +
    </Button>
  </div>
);

export default MoreButton;
